<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="Status == 2 || !canWrite" @click.native="openDialog()"> 单据选择 </el-button>
        </el-dropdown>
        <el-button type="primary" :disabled="Status === 2 || !canWrite" style="margin-left: 4px" @click.native="save">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || Status === 2 || !canWrite">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" @click.native="onIssue">任务下发</el-button>
        <!-- <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave">
            联查<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">采购订单情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item" @click.native="goJump(2)">进货单情况</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <!-- <el-button type="primary" style="margin-left: 4px" :disabled="!isSave" @click="print">打印</el-button> -->
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon :rules="rules">
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期" label-width="100px" prop="DocDate">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker v-else v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="v => getPreviewNo(v)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码" label-width="100px" prop="DocNo" class="is-required">
            <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span>
            <el-input style="width: 180px" v-else v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="业务类型:" label-width="100px">
            <span class="not-edit" style="width: 180px" v-if="Status === 2">{{ data.BusinessType }}</span>
            <el-select v-else v-model="data.BusinessTypeId" style="width: 180px">
              <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商" label-width="100px" prop="TradeUnitId" class="is-required">
            <span class="not-edit" style="display: block; width: 180px" v-if="Status == 2 || !editTrade">{{ data.TradeUnitName }}</span>
            <!-- <select-input
              v-else
              placeholder="请选择供应商"
              :label="data.TradeUnitName"
              v-model="data.TradeUnitId"
              @click="openTradeunit"
              @clear="clearTradeUnit"
            /> -->
            <el-select v-else style="width: 180px" @change="changeTradeUnit" filterable v-model="data.TradeUnitId">
              <el-option v-for="item in tradeUnitList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库仓库:" label-width="100px" prop="WarehouseId">
            <span class="not-edit" v-if="Status === 2">{{ data.WarehouseName }}</span>
            <el-select v-else filterable style="width: 180px" v-model="data.WarehouseId" @change="changeWarehouseName">
              <el-option v-for="item in warehouse" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经手人:" prop="EmpId" label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" @keydown.native.enter="openEmp" style="width: 180px" />
          </el-form-item>
          <el-form-item label="制单人:" label-width="100px">
            <span class="span" style="width: 180px">{{ data.MakeEmpName }}</span>
          </el-form-item>
          <!-- <div class="mtx10">
            <div class="flex">
              <div class="text el-form-item__label">备注</div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 3 }"
                v-model="data.Remark"
                :disabled="Status === 2"
              ></el-input>
            </div>
          </div> -->
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="100px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
        stripe
        style="margin-top: 18px"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        @row-click="add"
        ref="table1"
        v-keymove="newLine"
        v-if="showDetail"
      >
        <insert-row @on-insert="onInsert" />
        <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <span v-if="Status === 2">{{ row.Remark }}</span>
            <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column label="仓库 " prop="WarehouseName" align="left" min-width="180" v-if="showField('仓库')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
            <el-select v-else style="width: 140px" @change="editT(row)" v-model="row.WarehouseId">
              <el-option v-for="item in warehouse" :key="item.key" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="WarehousePositionId" label="库位" min-width="120" v-if="showField('库位')">
          <template slot-scope="{ row }">
            <el-select v-model="row.WarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.WarehouseId)">
              <el-option v-for="item in row.WarehousePositionList" :key="item.WarehousePositionId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="存货名称" align="left" min-width="120" v-if="showField('存货名称')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText($event, row)"
              @click.native="resetFun"
              @currentPage="currentPage($event, row)"
              :pageType="true"
            />
          </template>
        </el-table-column>
        <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160" v-if="showField('存货编码')"> </el-table-column>
        <el-table-column align="left" label="批号" min-width="300px" v-if="showField('批号')">
          <template slot-scope="{ row, $index }">
            <span v-if="!row.ProductName && !row.WarehouseName" style="color: #999">请先选择存货和仓库</span>
            <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
            <span class="not-edit" v-else-if="Status === 2">{{ row.BatchNumber }}</span>
            <account-select
              v-else
              v-model="row.BatchNumber"
              :Head="Head"
              :source="batchList"
              :listTotal="batchListTotal"
              :pageType="true"
              :pageSize="batchPageParams.pageSize"
              :pageIndex="batchPageParams.pageIndex"
              @select="onSelBatch($event, row, $index)"
              @inputText="inputTextBatch($event, row)"
              @click.native="onOpenBatch($event, row, $index)"
              @currentPage="currentPageBatch($event, row)"
              keyword="BatchNumber"
            />
          </template>
        </el-table-column>
        <el-table-column align="left" label="批号起始日期" min-width="220px" v-if="showField('批号起始日期')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toDateString(row.BatchStartDate) }}</span>
            <el-date-picker
              v-else
              v-model="row.BatchStartDate"
              :disabled="!row.IsBatchNumber"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              @change="changeBatchStartDate(row)"
              placeholder="选择日期"
              style="width: 190px"
              :clearable="false"
            />
          </template>
        </el-table-column>
        <el-table-column label="规格型号" prop="ProductSpec" align="left" min-width="100" v-if="showField('规格型号')"> </el-table-column>
        <el-table-column label="属性" prop="PropertyId" align="left" min-width="100" key="table1_6" v-if="showField('属性')">
          <template slot-scope="{ row }">
            <el-select
              v-if="(row.UseProcess && Status !== 2 && (row.SourceId === 0 || row.SourceId == null)) || (Status !== 2 && row.PropertyId)"
              v-model="row.PropertyId"
              @change="changeProperty($event, row)"
            >
              <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="left" min-width="100" key="column1" v-if="showField('颜色')">
          <template slot-scope="{ row }">
            <el-select
              v-if="(row.UseColor && Status !== 2 && (row.SourceId === 0 || row.SourceId == null)) || (Status !== 2 && row.ColorId)"
              v-model="row.ColorId"
              filterable
              @change="changeColor($event, row)"
            >
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status == 0"></el-option>
            </el-select>
            <span class="not-edit" v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位" min-width="120px" v-if="showField('计量单位')">
          <template slot-scope="{ row, $index }">
            <el-select v-if="row.Units && row.Units.length > 0" v-model="row.UnitId" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
          <!--  -->
        </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="right" min-width="100" v-if="showField('数量')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input v-else type="text" v-model="row.Quantity" @change="changeQuantity($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
          <template slot-scope="{ row, $index }">
            <!-- <span>{{ row }}{{ $index }}</span> -->
            <el-select v-if="row.Units && row.Units.length > 0" v-model="row.UnitId2" :disabled="Status === 2">
              <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量2" prop="Quantity2" align="right" min-width="100" v-if="showField('数量2')">
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2" @change="changeQuantity2($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="Price" align="right" min-width="100" v-if="canPrice && showField('单价')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
            <el-input type="text" v-else v-model="row.Price" @change="changePrice($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="金额" prop="Amount" align="right" min-width="100" v-if="canPrice && showField('金额')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
            <el-input type="text" v-else v-model="row.Amount" @change="changeAmount($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="现存量" prop="ExistQuantity" align="right" min-width="100" v-if="showField('现存量')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="条形码" align="center" min-width="140">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span> 
            <vue-barcode
              v-if="row.ProductNo"
              :value="row.ProductNo"
              width="1"
              height="20"
              fontSize="10"
            ></vue-barcode>
          </template>
        </el-table-column>-->
        <el-table-column label="单价2" prop="Price2" align="right" min-width="100" v-if="canPrice && showField('单价2')">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
            <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="right" label="换算率" v-if="showField('换算率')">
          <template slot-scope="{ row, $index }">
            <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
            <span v-else-if="row.UnitType == 0"></span>
            <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="费用调整" prop="NewExpense" align="right" min-width="100" v-if="canPrice && showField('费用调整')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ row.NewExpense }}</span>
            <!-- <span class="not-edit" v-if="Status === 2">{{ row.NewExpense }}</span>
            <el-input
              type="text"
              v-else
              v-snum
              v-model="row.NewExpense"
            ></el-input> -->
          </template>
        </el-table-column>
        <el-table-column label="总成本" prop="Cost" align="right" min-width="100" v-if="canPrice && showField('总成本')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ row.Cost }}</span>
            <!-- <span class="not-edit" v-if="Status === 2">{{ row.Cost }}</span>
            <el-input type="text" v-else v-snum v-model="row.Cost"></el-input> -->
          </template>
        </el-table-column>
        <el-table-column label="费用金额" prop="Amount2" align="right" min-width="100" v-if="canPrice && showField('费用金额')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.Amount2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计进货数量" prop="InQuantity" align="right" min-width="100" v-if="showField('累计进货数量')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.InQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计进货数量2" prop="InQuantity2" align="right" min-width="100" v-if="showField('累计进货数量2')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.InQuantity2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计核算数量" prop="AccountQuantity" align="right" min-width="100" v-if="showField('累计核算数量')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AccountQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源单据" align="left" min-width="100" v-if="showField('来源单据')">
          <template slot-scope="{ row }">
            <span v-if="row.SourceType === 1">采购订单</span>
            <span v-if="row.SourceType === 2">进货单</span>
          </template>
        </el-table-column>
        <el-table-column label="来源单号" prop="SourceNo" align="left" min-width="180px" v-if="showField('来源单号')"></el-table-column>
        <el-table-column label="赠品" prop="IsGift" align="center" min-width="100" v-if="showField('赠品')">
          <template slot-scope="{ row }">
            <el-checkbox @change="changeIsGift($event, row)" :disabled="Status === 2" v-model="row.IsGift"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="可用量" prop="AvailableQuantity" align="right" min-width="100" v-if="showField('可用量')">
          <template slot-scope="{ row }">
            <span class="not-edit">{{ $commonJs.toThousands(row.AvailableQuantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计入库数" prop="InQuantity" align="left" min-width="100px" v-if="showField('累计入库数')"></el-table-column>
        <el-table-column align="left" label="预计到货日期" min-width="180px" v-if="showField('预计到货日期')">
          <template slot-scope="{ row }">
            <span v-if="ReviewStatus">{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
            <el-date-picker v-else v-model="row.DeliveryDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 140px" @change="editT(row)">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="del(row, $index)" :disabled="Status === 2">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <print-dialog ref="printDialog" :columns="columns" :data="columnData" :form-data="formData"></print-dialog>
    <emptor-select ref="emptorDialog" in-dialog selectable multiple @select-multiple="setOrderList($event, '采购订单')" />
    <stock-select ref="stockDialog" in-dialog selectable multiple @select-multiple="setOrderList($event, '进货单')" :ordertype="ordertype" />
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode'
import editDialog from './editDialog'
import accountSelect from '@/components/business/stock/select'
import emptorSelect from './listDialog'
import stockSelect from '@/components/business/purchase/stock/listDialog'
import optionMixins from '@/mixins/option'
import empDialog from '@/components/personnel/result/record/listDialog'
import printDialog from '@/components/common/printDialog/printDialog'
import tradeunitDialog from '@/components/basedata/business/come/listDialog'
import fieldDialog from '@/components/common/fieldDialog'

export default {
  name: 'editentrystore',
  mixins: [optionMixins],
  components: {
    editDialog,
    accountSelect,
    VueBarcode,
    empDialog,
    printDialog,
    emptorSelect,
    stockSelect,
    tradeunitDialog,
    fieldDialog
  },
  data() {
    return {
      accountkey: Math.random(),
      viewType: 'create',
      sourceTypeApi: require('@/api/ba/sourceType').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      colorApi: require('@/api/ba/color').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/stock/stInDocTask').default,
      pdApi: require('@/api/ba/product').default,
      propertyApi: require('@/api/ba/property').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      warehousePositionApi: require('@/api/ba/warehousePosition').default,
      propertyList: [],
      Mode: 0,
      colors: [],
      warehouse: [],
      businessTypeList: [],
      tradeUnitList: [],
      Status: 0,
      ordertype: '采购入库通知单',
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: '',
        BusinessType: '',
        BusinessTypeId: null,
        // BusinessTypeNo: "",
        TradeUnitId: null,
        TradeUnitName: '',
        WarehouseId: null,
        WarehousePositionId: null,
        WarehousePositionName: '',
        WarehouseName: '',
        EmpId: '',
        EmpName: '',
        MakeEmpName: '',
        MakeEmpId: 0,
        ReviewEmpName: '',
        ReviewEmpId: 0,
        ReviewDate: '',
        Remark: '',
        ProcessingType: 0,
        WorkShopId: 0,
        BatchNumber: '',
        BatchStartDate: this.$commonJs.getToday(),
        DeliveryDate: ''
      },
      editTrade: true,
      isSave: false,
      businessTypeList: [],
      date: [],
      tableData: [
        {
          T: 0,
          NewExpense: null,
          Cost: null,
          Amount2: null,
          Colors: [],
          Units: [],
          Units2: [],
          WarehouseName: '',
          WarehouseId: null,
          WarehousePositionId: null,
          WarehousePositionName: null,
          WarehousePositionList: [],
          Barcode: '',
          ProductId: 0,
          ProductName: '',
          ProductNo: '',
          ProductSpec: '',
          ColorName: '',
          ColorId: '',
          UnitId: '',
          UnitName: '',
          Quantity: null,
          ReQuantity: null,
          Price: null,
          Amount: null,
          UnitId2: '',
          UnitName2: '',
          Quantity2: null,
          ReQuantity2: null,
          Price2: null,
          Rate: null,
          InQuantity: null,
          InQuantity2: null,
          AccountQuantity: null,

          SourceId: 0,
          SourceNo: '',
          SourceType: '',
          SourceDtsId: 0,

          IsGift: false,
          AvailableQuantity: null,
          ExistQuantity: null,

          Remark: '',
          TotalInQuantity: null,
          BatchNumber: '',
          BatchStartDate: this.$commonJs.getToday(),
          DeliveryDate: ''
        }
      ],
      isUseColor: true,
      isUseProcess: true,
      delTableData: [],
      title: '',
      bool: true,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      rules: {
        DocDate: [{ required: true, message: '单据日期不能为空' }],
        // DocNo: [{ required: true, message: "单据编码不能为空" }],
        EmpId: [{ required: true, message: '经手人不能为空' }],
        BusinessTypeId: [{ required: true, message: '业务类型不能为空' }],
        // TradeUnitId: [{ required: true, message: "供应商不能为空" }],
        WarehouseId: [{ required: true, message: '仓库不能为空' }]
      },
      isUseColor: true,
      isUseProcess: true,
      printList: [],
      columns: [
        {
          label: '仓库',
          data: {
            key: 'WarehouseName',
            label: '仓库',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '条形码',
          data: {
            key: 'Barcode',
            label: '条形码',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '条形码',
          data: {
            key: 'Barcode',
            label: '条形码',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '存货名称',
          data: {
            key: 'ProductName',
            label: '存货名称',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '存货编码',
          data: {
            key: 'ProductNo',
            label: '存货编码',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '规格型号',
          data: {
            key: 'ProductSpec',
            label: '规格型号',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '颜色',
          data: {
            key: 'ColorName',
            label: '颜色',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '计量单位',
          data: {
            key: 'UnitName',
            label: '计量单位',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '应收数量',
          data: {
            key: 'Quantity',
            label: '应收数量',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '实收数量',
          data: {
            key: 'ReQuantity',
            label: '实收数量',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '单价',
          data: {
            key: 'Price',
            label: '单价',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '金额',
          data: {
            key: 'Amount',
            label: '金额',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '计量单位2',
          data: {
            key: 'UnitName2',
            label: '计量单位2',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '应收数量2',
          data: {
            key: 'Quantity2',
            label: '应收数量2',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '实收数量2',
          data: {
            key: 'ReQuantity2',
            label: '实收数量2',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        },
        {
          label: '单价2',
          data: {
            key: 'Price2',
            label: '单价2',
            isSum: false,
            style: {
              width: 100,
              textAlign: 'center',
              verticalAlign: 'middle',
              fontSize: 16,
              fontWeight: 600,
              fontStyle: 'normal',
              fontFamily: '宋体'
            }
          }
        }
      ],
      columnData: [],
      formData: [],
      btnRefs: ['btn1', 'btn2', 'btn3', 'btn4', 'btn5', 'btn6', 'btn7'],
      currentBtnRefIndex: 0,
      formitemRefs: ['formitem1', 'formitem2', 'formitem3', 'formitem4', 'formitem5', 'formitem6'],
      currentFormitemRefIndex: 0,
      currentRowIndex: 0,
      currentColumnIndex: 0,
      columnLength: 10,
      detailFields: [],
      showDetail: false,
      Head: [
        { Value: 'BatchNumber', Name: '批号', Width: '180' },
        { Value: 'WarehouseName', Name: '仓库', Width: '100' },
        { Value: 'ColorName', Name: '颜色', Width: '80' },
        { Value: 'PropertyName', Name: '属性', Width: '80' },
        { Value: 'BatchStartDate', Name: '批次起始日期', Width: '100' },
        { Value: 'ExpireDate', Name: '有效期至', Width: '100' },
        { Value: 'BaseUnitName', Name: '主单位', Width: '80' },
        { Value: 'BaseQuantity', Name: '现存量', Width: '80' }
      ],
      batchListTotal: 0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      batchList: []
    }
  },
  created() {
    this.init()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/purchaseinbound')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/purchaseinbound')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/purchaseinbound')
    },
    ReviewStatus() {
      return false
    }
  },
  mounted() {
    this.viewType = this.$route.params.type
    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
    } else if (this.$route.params.type === 'edit') {
      this.viewType = 'edit'
      this.editInit(this.$route.params.data)
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '采购入库通知单', Url: 'business/stock/purchaseinbound/edit' })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '采购入库通知单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then(that => {
        that.getData({ TradeUnitTypes: [1, 2] })
        // that.getData();
      })
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId
      this.data.TradeUnitName = data.FullName
    },
    clearTradeUnit() {
      this.data.TradeUnitId = 0
      this.data.TradeUnitName = ''
    },
    onInsert(e) {
      let { type, index } = e

      this.interpolate(null, index, type)
    },
    // 任务下发
    onIssue() {
      const o = { ids: [this.data.DocId], Status: 1 }
      this.api.updateStatus(o).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg)
          this.reload()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          res = await this.sourceTypeApi.info('采购订单')
          params.SourceType = res.SourceTypeId
          ids = this.tableData
            .filter(item => {
              return item.SourceType === res.SourceTypeId
            })
            .map(item => {
              return item.SourceId
            })
          if (ids.length === 0) {
            this.$message.error('单据未引用采购订单，无法进行联查')
          } else {
            params.Ids = ids
            this.$router.push({ name: 'emptor', params: params })
          }

          break
        case 2:
          res = await this.sourceTypeApi.info('进货单')
          params.SourceType = res.SourceTypeId
          ids = this.tableData
            .filter(item => {
              return item.SourceType === res.SourceTypeId
            })
            .map(item => {
              return item.SourceId
            })
          if (ids.length === 0) {
            this.$message.error('单据未引用进货单，无法进行联查')
          } else {
            params.Ids = ids
            this.$router.push({ name: 'stock', params: params })
          }

          break
      }
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        NewExpense: null,
        Cost: null,
        Amount2: null,
        Colors: [],
        Units: [],
        Units2: [],
        WarehouseName: '',
        WarehouseId: null,
        WarehousePositionId: null,
        WarehousePositionName: null,
        Barcode: '',
        ProductId: 0,
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        ColorName: '',
        ColorId: '',
        UnitId: '',
        UnitName: '',
        Quantity: null,
        ReQuantity: null,
        Price: null,
        Amount: null,
        UnitId2: '',
        UnitName2: '',
        Quantity2: null,
        ReQuantity2: null,
        Price2: null,
        Rate: '',
        InQuantity: null,
        InQuantity2: null,
        AccountQuantity: null,

        SourceId: 0,
        SourceNo: '',
        IsGift: false,
        AvailableQuantity: null,
        ExistQuantity: null,
        SourceType: '',
        SourceDtsId: 0
      }
      if (type == 'down') {
        index = index + 1
      }
      this.tableData.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableData))
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = copy
      })
      console.log('this.tableData', this.tableData)
    },
    BusinessChange(val) {
      console.log('val', val)
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      if (status) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
          item.Amount = item.Amount == null ? item.Amount : Number((item.Quantity * item.Price).toFixed(2))

          if (item.T !== 0) {
            item.T = 1
          }
        })
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity == null ? item.Quantity : Math.abs(item.Quantity)
          item.Quantity2 = item.Quantity2 == null ? item.Quantity2 : Math.abs(item.Quantity2)
          item.Amount = item.Amount == null ? item.Amount : Number((item.Quantity * item.Price).toFixed(2))

          if (item.T !== 0) {
            item.T = 1
          }
        })
      }
    },
    // 获取进货单明细
    async setOrderList(data, type) {
      console.log(data, 'data')
      let Quantity = this.tableData.map(i => i.ProductId)
      let SourceType = null
      let addList = []
      if (type === '采购订单') {
        const res = await this.sourceTypeApi.info('采购订单')
        let SourceType = res.SourceTypeId
        this.data.TradeUnitId = data.TradeUnitId || null
        this.data.TradeUnitName = data.TradeUnitName

        if (data.TradeUnitId) this.editTrade = false
        addList = data.List.reduce((arr, item) => {
          console.log('item', item)
          if (!Quantity.includes(item.ProductId)) {
            arr.push({
              //====
              NewExpense: null,
              Cost: null,
              Amount2: null,
              InQuantity: null,
              InQuantity2: null,
              AccountQuantity: null,
              DocProductId: 0,
              AvailableQuantity: null,
              ExistQuantity: null,
              Requirement: '',
              ...item,
              Quantity: item.PurchaseQuantity,
              ReQuantity: item.PurchaseQuantity,
              Quantity2: item.Quantity2,
              ReQuantity2: item.Quantity2,
              Price2: item.Amount / item.Quantity2,
              SourceType,
              UnitId: item.PuUnitId,
              UnitName: item.UnitName,
              UnitId2: item.UnitId2,
              UnitName2: item.Unit2Name,
              WarehouseId: this.data.WarehouseId,
              WarehouseName: this.data.WarehouseName,
              WarehousePositionId: null,
              WarehousePositionName: null,
              WarehousePositionList: [],
              // SourceDtsId:item.

              SourceId: item.OrderId,
              SourceDtsId: item.OrderProductId,
              SourceNo: data.Order,
              PropertyId: item.PropertyId ? item.PropertyId : 0,
              PropertyName: item.PropertyName,
              ColorId: item.ColorId,
              ColorName: item.ColorName
            })
          }
          console.log('arr', arr)
          return arr
        }, [])
      } else if (type === '进货单') {
        const res = await this.sourceTypeApi.info('进货单')
        let SourceType = res.SourceTypeId
        var businessType = this.businessTypeList.filter(x => {
          return x.BusinessTypeId == data.BusinessTypeId
        })[0]
        this.data.BusinessType = businessType.BusinessType
        this.data.BusinessTypeId = businessType.BusinessTypeId
        this.data.MinusEntry = businessType.MinusEntry
        console.log('this.data', this.data)
        this.data.TradeUnitId = data.TradeUnitId || null
        this.data.TradeUnitName = data.TradeUnitName
        if (data.List[0].WarehouseId) {
          this.data.WarehouseId = data.List[0].WarehouseId
        }
        if (data.List[0].WarehouseName) {
          this.data.WarehouseName = data.List[0].WarehouseName
        }

        if (data.TradeUnitId) this.editTrade = false
        addList = data.List.reduce((arr, item) => {
          if (!Quantity.includes(item.ProductId)) {
            console.log('==item===', item.OrderProductId)
            arr.push({
              NewExpense: null,
              Cost: null,
              Amount2: null,
              InQuantity: null,
              InQuantity2: null,
              AccountQuantity: null,
              AvailableQuantity: null,
              ExistQuantity: null,

              OrderProductId: 0,
              Requirement: '',
              ...item,
              DocId: 0,
              DocProductId: 0,
              Quantity: item.PuQuantity,
              Quantity2: item.Quantity2,
              ReQuantity: item.PuQuantity,
              ReQuantity2: item.Quantity2,
              //ReQuantity2
              // ReQuantity: item.PurchaseQuantity,
              UnitId2: item.UnitId2,
              UnitName2: item.UnitName2,
              UnitId: item.PuUnitId,
              UnitName: item.PuUnitName,
              WarehouseId: this.data.WarehouseId,
              WarehouseName: this.data.WarehouseName,
              WarehousePositionId: null,
              WarehousePositionName: null,
              WarehousePositionList: [],
              SourceType,
              // SourceDtsId:item.
              SourceId: item.DocId,
              SourceDtsId: item.DocProductId,
              SourceNo: data.Order,
              PropertyId: item.PropertyId ? item.PropertyId : 0,
              PropertyName: item.PropertyName,
              ColorId: item.ColorId,
              ColorName: item.ColorName
            })
          }
          return arr
        }, [])
      }

      addList.forEach((item, i) => {
        if (this.data.MinusEntry) {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
        } else {
          item.Quantity = Math.abs(item.Quantity)
          item.Quantity2 = Math.abs(item.Quantity2)
        }

        item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true

        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.UnitId) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.UnitId)
          const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
          const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引
          const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
          if (findIndex == IsMainIndex) {
            //判断当前销售单位是否为主单位
            item.Rate = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].Rate || 0
            item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
            item.IsMain = true
          } else {
            item.IsMain = false
            //如果当前是赋单位
            item.Rate = item.Units[findIndex].Rate
            item.ChangeType = item.Units[findIndex].ChangeType
          }
          console.log('====item====', item)
          this.changeQuantity(item.Quantity, item, i, 1)
        } else {
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }
      })
      this.tableData.unshift(...addList)

      let _isUseProcess = this.tableData.find(item => {
        return item.UseProcess === true
      })

      if (_isUseProcess == null) {
        this.isUseProcess = false
      } else {
        this.isUseProcess = true
      }

      let _isUseColor = this.tableData.find(item => {
        return item.UseColor === true
      })

      if (_isUseColor == null) {
        this.isUseColor = false
      } else {
        this.isUseColor = true
      }
    },
    handleSelectionChange(arr) {
      this.printList = arr
    },
    editInit(data) {
      this.viewType = 'edit'
      this.isSave = true

      console.log('this.data 前', data)

      let {
        BusinessType,
        BusinessTypeId,
        // BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        InType,
        Status,
        EmpId,
        EmpName,
        MakeEmpId,
        MakeEmpName,
        Products,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        TradeUnitId,
        TradeUnitName,
        // TradeUnitShortName,
        WarehouseId,
        WarehouseName,
        WarehousePositionId,
        WarehousePositionName
      } = data

      this.Status = Status

      this.data = {
        BusinessType,
        BusinessTypeId,
        // BusinessTypeNo,
        DocDate,
        DocId,
        DocNo,
        InType,
        EmpId,
        EmpName,
        MakeEmpId,
        MakeEmpName,
        Remark,
        ReviewEmpId,
        ReviewEmpName,
        ReviewTime,
        TradeUnitId,
        TradeUnitName,
        // TradeUnitShortName,
        WarehouseId,
        WarehouseName,
        WarehousePositionId,
        WarehousePositionName,
        WarehousePositionList: [
          {
            WarehousePositionId,
            WarehousePositionName
          }
        ]
      }

      console.log('this.data 后 ', this.data)

      Products = this.initProducts(Products)

      this.tableData = Products
      var businessType = this.businessTypeList.filter(x => {
        return x.BusinessTypeId == this.data.BusinessTypeId
      })[0]
      this.data.BusinessType = businessType.BusinessType
      this.data.BusinessTypeId = businessType.BusinessTypeId
      this.data.MinusEntry = businessType.MinusEntry
      console.log('businessType', businessType)
      if (this.data.MinusEntry) {
        this.tableData.forEach((item, index) => {
          item.Quantity = item.Quantity > 0 ? 0 - item.Quantity : item.Quantity
          item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
          item.WarehousePositionList = [
            {
              WarehousePositionId: item.WarehousePositionId,
              WarehousePositionName: item.WarehousePositionName
            }
          ]
        })
      } else {
        this.tableData.forEach((item, index) => {
          item.Quantity = Math.abs(item.Quantity)
          item.Quantity2 = Math.abs(item.Quantity2)
        })
      }
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('采购入库通知单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DocNo = res.Data.PreviewNo
          // this.data.InType = SourceTypeId;
        } else {
          this.$message.warning('获取采购入库通知单编号失败')
        }
      })
    },
    initProducts(Products) {
      Products.forEach(item => {
        item.T = null
        item.IsBatchNumber = item.BatchNumber ? true : false
        item.IsBatchNumber = item.BatchNumber ? true : false

        item.WarehousePositionList = [{ WarehousePositionId: item.WarehousePositionId, WarehousePositionName: item.WarehousePositionName }]

        item.ColorId = item.ColorId !== 0 ? item.ColorId : null
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null

        item.isSource = item.SourceId === 0 || item.SourceId == null ? false : true

        if (item.Units.length === 0 || item.Units == null) {
          item.UnitType = 0
        } else {
          item.UnitType = 1
          let UnitItem = item.Units.filter(v => {
            return item.UnitId === v.UnitId
          })[0]
          item.IsMain = UnitItem.IsMain

          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }

        // if (Units.length !== 0) {
        //   item.ChangeType = Units[0].ChangeType;
        //   item.Rate1 = Units[0].Rate;
        //   item.UnitId = Units[0].UnitId;
        //   item.UnitName = Units[0].UnitName;
        // }

        // item.Units2 = item.Units.filter((v) => {
        //   return !v.IsMain;
        // });
      })
      return Products
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    changeTradeUnit(val) {
      let item = this.tradeUnitList.filter(item => {
        return val === item.key
      })[0]
      this.data.TradeUnitName = item.label
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      if (data.IsMain) {
        this.tableData[index].IsMain = false
      } else {
        this.tableData[index].IsMain = true
      }
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        num = row.ReQuantity
        row.ReQuantity = row.ReQuantity2
        row.ReQuantity2 = num

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex)
          //  row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.Quantity = row.Quantity2
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(data.Rate))
        }
      }
      this.changeQuantity2(this.tableData[index].Quantity2, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)

      if (row.ReQuantity && row.ReQuantity2) {
        row.ReQuantity = row.Quantity
        row.ReQuantity2 = row.Quantity2
      }
    },

    changeQuantity(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)

      if (this.data.MinusEntry) {
        row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T == 3) this.tableData[index].T = 1
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }
        } else {
          row.Quantity2 = this.getQuantity(data * Number(row.Rate))
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.Quantity)
          }

          // if(row.ChangeType == 1 && row.Quantity2 != 0){
          //   row.Rate= Math.abs(Number(row.Quantity2/data)).toFixed(2);
          //   if(type === 0){
          //     let val = this.setNumber(Math.abs(row.Amount / data))
          //     row.Price = this.getPrice(val);
          //   }
          // }else if(row.Quantity2 == 0){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }else if(row.ChangeType == 0 ){
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity((data * Number(row.Rate)))
          //   if(type === 0){
          //     row.Amount = this.setAmount(row.Price, row.Quantity);
          //   }
          // }
        }
      } else {
        row.Quantity2 = 0
        row.Amount = this.setAmount(row.Price, row.Quantity)
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    init() {
      let SET_PurchaseReceipt = null
      if (localStorage.getItem('SET_PurchaseReceipt') === 'true') {
        SET_PurchaseReceipt = true
      } else {
        SET_PurchaseReceipt = false
      }

      this.propertyApi
        .list({
          Status: 1
        })
        .then(res => {
          if (res.Code === 0) {
            this.propertyList = res.Data
          }
        })

      this.businessTypeApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.businessTypeList = res.Data
          if (!this.data.BusinessTypeId) {
            this.data.BusinessTypeId = res.Data[0].BusinessTypeId
            // this.data.BusinessTypeNo = res.Data[0].BusinessTypeNo;
            this.data.BusinessType = res.Data[0].BusinessType
          }
        }
      })
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
        this.data.MakeEmpId = user.id
        this.data.MakeEmpName = user.name
      }

      this.pdApi
        .list({
          PageIndex: this.pageParams.pageIndex,
          PageSize: this.pageParams.pageSize,
          // ProcessStage: 0,
          Property: '采购',
          Status: 1
        })
        .then(res => {
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
        })

      let WarehouseTypes = []
      if (SET_PurchaseReceipt) {
        WarehouseTypes = [1, 3]
      } else {
        WarehouseTypes = [1]
      }
      this.warehouseApi.list({ Status: 1, WarehouseTypes: WarehouseTypes }).then(res => {
        if (res.Code === 0) {
          if (this.viewType !== 'edit') {
            this.data.WarehouseId = res.Data[0].WarehouseId
            this.data.WarehouseName = res.Data[0].WarehouseName
          }
          this.warehouse = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })

          console.log('this.warehouse', this.warehouse)
        }
      })

      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data.map(item => {
            return {
              key: item.TradeUnitId,
              label: item.FullName,
              value: item.TradeUnitId
            }
          })
        }
      })

      this.callOptionApi()
      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = '采购入库通知单'
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.data.InType = SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data

              if (this.viewType !== 'edit') {
                 console.log('this.businessTypeList[0]', this.businessTypeList[0]);
                if (this.businessTypeList[0]) {
                  this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
                  this.data.BusinessType = this.businessTypeList[0].BusinessType
                  this.data.MinusEntry = this.businessTypeList[0].MinusEntry
                  this.changeNumber(this.data.MinusEntry)
                }
              } else {
                console.log('this.data.BusinessTypeId', this.data.BusinessTypeId)
                let item = this.businessTypeList.filter(item => {
                  return item.BusinessTypeId === this.data.BusinessTypeId
                })[0]

                this.data.MinusEntry = item.MinusEntry

                this.changeNumber(this.data.MinusEntry)
              }
            }
          })
        }
      })
      this.setTbField()
    },
    integerQuantity(row, index) {
      if (this.data.MinusEntry) {
        row.Quantity = 0 - row.Quantity
        row.Quantity2 = 0 - row.Quantity2
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
      }
    },
    // changeBusinessType(val) {
    //   let item = this.businessTypeList.filter((item) => {
    //     return val === item.BusinessTypeId;
    //   })[0];

    //   this.data.BusinessTypeId = item.BusinessTypeId;
    //   this.data.BusinessTypeNo = item.BusinessTypeNo;
    //   this.data.BusinessType = item.BusinessType;
    // },
    changeWarehouseName(val) {
      let item = this.warehouse.filter(item => {
        return val === item.value
      })[0]

      this.data.WarehouseId = item.value
      this.data.WarehouseName = item.label
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].T !== 0) {
          this.tableData[i].T = 1
        }
        ;(this.tableData[i].WarehouseId = item.value), (this.tableData[i].WarehouseName = item.label)
      }
    },
    changeProperty(val, row) {
      this.editT(row)

      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]

      row.PropertyName = item.PropertyName
    },
    changeColor(val, row) {
      this.editT(row)

      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      row.ColorName = item.ColorName
    },
    changePrice(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price = this.getPrice(val)
      row.Amount = this.setAmount(row.Price, row.Quantity)

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2)
      }
    },
    changePrice2(val, row) {
      this.editT(row)

      val = this.setNumber(val)
      row.Price2 = this.getPrice(val)

      row.Amount = this.setAmount(row.Price2, row.Quantity2)
      if (row.Quantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.Quantity)
      }
    },
    changeAmount(val, row) {
      this.editT(row)

      if (this.data.MinusEntry) {
        val = val > 0 ? 0 - val : val
      } else {
        val = Math.abs(val)
      }
      row.Amount = Number(this.setNumber(val))

      if (row.Quantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.Quantity))
      } else {
        this.$message({ type: 'warning', message: '实收数量不能为0' })
        row.Amount = 0
        return
      }

      if (row.Units.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2))
        } else {
          this.$message({ type: 'warning', message: '实收数量2不能为0' })
          row.Amount = 0
          return
        }
      }
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2))
    },
    changeIsGift(val, row) {
      row.IsGift = val
      if (row.IsGift) {
        row.Price = 0
        row.Price2 = 0
        row.Amount = 0
      }
    },
    changeUnitId2(val, row) {
      this.editT(row)

      let item = row.Units2.filter(item => {
        return item.UnitId === val
      })[0]

      row.UnitId2 = item.UnitId
      row.UnitName2 = item.UnitName

      row.Rate2 = item.Rate
      row.ChangeType2 = item.ChangeType

      row.Rate = row.Rate1 / row.Rate2
    },

    onSelect(e, row) {
      if (this.data.WarehouseId == 0 || this.data.WarehouseId == null) return this.$message.warning('请先选择仓库')

      this.editT(row)
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.DeliveryDate = row.DeliveryDate ? row.DeliveryDate : null
      row.ColorId = null
      row.PropertyId = null

      row.SourceId = 0
      row.SourceNo = ''
      row.SourceType = 0
      row.SourceDtsId = 0

      row.Colors = []
      row.Units2 = []

      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.Colors = e.Colors
      row.Units = e.Units
      row.UseColor = e.UseColor
      row.UseProcess = e.UseProcess
      row.WarehouseId = this.data.WarehouseId
      row.WarehouseName = this.data.WarehouseName

      ;(row.WarehousePositionId = null),
        (row.WarehousePositionName = null),
        (row.WarehousePositionList = []),
        // row.ReQuantity = 0;
        // row.ReQuantity2 = 0;
        (row.UnitId2 = e.UnitId2)
      row.UnitId = e.SkUnitId
      // row.Quantity = 0;
      // row.Quantity2 = 0;
      // row.Price = 0;
      // row.Price2 = 0;
      // row.Amount = 0;
      row.SourceType = 0
      row.ChangeType = 0
      row.UnitType = 0

      if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId
        row.UnitName = e.SkUnitName
        row.UnitId2 = 0
        // row.SaUnitName = e.SaUnitName;
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          // row.ChangeType1 = data.ChangeType;

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = assistData.Rate.toFixed(5)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = data.Rate.toFixed(5)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId
          row.UnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = noMainData[0].Rate.toFixed(5)
          row.IsMain = true
        }
        if (row.IsMain) {
          row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate))
          row.Amount = this.setAmount(row.Price, row.Quantity)
        } else {
          row.Quantity2 = this.getQuantity(row.Quantity * Number(row.Rate))
          row.Amount = this.setAmount(row.Price, row.Quantity)
        }
        // row.ChangeType2 = assistData.ChangeType;
      }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      this.editT(row)
      row.Rate = data
      row.Rate = Number(row.Rate).toFixed(2)
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        row.Quantity2 = this.getQuantity(row.Quantity / Number(data))
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        row.Quantity = this.getQuantity(row.Quantity2 / Number(data))
      }

      let val = this.setNumber(row.Amount / row.Quantity)
      row.Price = this.getPrice(val)

      val = this.setNumber(row.Amount / row.Quantity2)
      row.Price2 = this.getPrice(val)
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1

      this.editT(row)

      let lastIsMain = row.IsMain
      this.tableData[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.UnitId == row.UnitId2) {
        let num = 0
        num = row.Quantity
        row.Quantity = row.Quantity2
        row.Quantity2 = num

        num = row.ReQuantity
        row.ReQuantity = row.ReQuantity2
        row.ReQuantity2 = num

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex)
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.Quantity2 = row.Quantity
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.Quantity = this.getQuantity(row.Quantity2 / Number(data.Rate))
        }
      }
      this.changeQuantity(this.tableData[index].Quantity, row, index, 1)

      let val = this.setNumber(Math.abs(row.Amount / row.Quantity))
      row.Price = this.getPrice(val)

      val = this.setNumber(Math.abs(row.Amount / row.Quantity2))
      row.Price2 = this.getPrice(val)

      if (row.ReQuantity && row.ReQuantity2) {
        row.ReQuantity = row.Quantity
        row.ReQuantity2 = row.Quantity2
      }
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].UnitName2 = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType2=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == '-' || data == '.' || data == '') {
        return
      }
      this.editT(row)
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      if (this.data.MinusEntry) {
        row.Quantity = row.Quantity > 0 ? 0 - row.Quantity : row.Quantity
        row.Quantity2 = row.Quantity2 > 0 ? 0 - row.Quantity2 : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else {
        row.Quantity = Math.abs(row.Quantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(data / row.Quantity)).toFixed(2)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2/换算率')
          // row.Quantity=Number(data/row.Rate).toFixed(2);
          if (row.Quantity === 0) {
            row.Quantity = this.getQuantity(data * row.Rate)
          } else {
            row.Quantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      } else {
        console.log('row.ChangeType', row.ChangeType)
        console.log('row.Quantity', row.Quantity)

        if (row.ChangeType == 1 && row.Quantity != 0) {
          row.Rate = Math.abs(Number(row.Quantity / data)).toFixed(2)
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data))
            row.Price2 = this.getPrice(val)
          }
        } else {
          console.log('数量1=数量2*换算率')
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.Quantity = this.getQuantity(data * row.Rate)
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2)
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId = this.tableData[index].Units[findIndex].UnitId
      this.tableData[index].SaUnitName = this.tableData[index].Units[findIndex].UnitName
      // this.tableData[index].ChangeType1=this.tableData[index].Units[findIndex].ChangeType

      if (Rate > 0) {
        this.tableData[index].Rate = Rate
      }
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ Property: '采购', pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text, row) {
      row.ProductName = text
      this.pdApi.list({ Property: '采购', pageIndex: 1, pageSize: 7, ProductName: text, Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data

          this.listTotal = res.Count
        }
      })
    },
    async openDialog() {
      this.title = '采购订单列表'
      this.bool = true
      const res = await this.sourceTypeApi.info('采购入库通知单')
      let OrderType = res.SourceTypeId
      if (this.data.TradeUnitId == null) {
        this.$message.warning('请先选择供应商')
        return
      }
      let that = await this.$refs.emptorDialog.open()

      that.getData({ Status: 2, LineAbort: false, OrderType, TradeUnitId: this.data.TradeUnitId })
    },

    del(row, index) {
      this.$confirm('确认删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        if (row.T !== 0) {
          row.T = 2
          row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
          row.ColorId = row.ColorId ? row.ColorId : 0
          this.delTableData.push(row)
        }
        this.tableData.splice(index, 1)
        if (this.tableData.length === 0) {
          this.newLine()
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    newLine() {
      if (this.Status === 2) {
        return
      }
      let o = {
        T: 0,
        NewExpense: null,
        Cost: null,
        Amount2: null,
        Colors: [],
        Units: [],
        Units2: [],
        WarehouseName: '',
        WarehouseId: null,
        Barcode: '',
        ProductId: 0,
        ProductName: '',
        ProductNo: '',
        ProductSpec: '',
        ColorName: '',
        ColorId: '',
        UnitId: '',
        UnitName: '',
        Quantity: null,
        ReQuantity: null,
        Price: null,
        Amount: null,
        UnitId2: '',
        UnitName2: '',
        Quantity2: null,
        ReQuantity2: null,
        Price2: null,
        Rate: null,
        InQuantity: null,
        InQuantity2: null,
        AccountQuantity: null,

        SourceId: 0,
        SourceNo: '',
        IsGift: false,
        AvailableQuantity: null,
        ExistQuantity: null,
        SourceType: 0,
        SourceDtsId: 0,
        Remark: '',
        TotalInQuantity: null,
        BatchNumber: '',
        BatchStartDate: this.$commonJs.getToday(),
        DeliveryDate: '',
        WarehousePositionId: null,
        WarehousePositionName: null,
        WarehousePositionList: []
      }

      this.tableData.push(o)
    },
    add(row, column) {
      if (column.label === '操作') {
        return
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine()
      }
    },
    getSaveTableData(arr, mode = 0) {
      arr = arr.filter(item => {
        return item.ProductName
      })
      let Products = []

      if (mode === 0) {
        let length = arr.length

        for (let i = 0; i < length; ++i) {
          let {
            T,
            NewExpense,
            Cost,
            Amount2,
            DocProductId = 0,
            DocId = 0,
            WarehouseName,
            WarehouseId,
            ProductName,
            ProductId,
            ProductNo,
            ProductSpec,
            ColorName,
            ColorId,
            UnitId,
            UnitName,
            Quantity,
            ReQuantity,
            Price,
            Amount,
            UnitId2,
            UnitName2,
            Quantity2,
            ReQuantity2,
            Price2,
            Rate,
            InQuantity,
            InQuantity2,
            AccountQuantity,
            PropertyId,

            SourceId,
            SourceNo,
            IsGift,
            AvailableQuantity,
            ExistQuantity,
            SourceType,
            SourceDtsId,
            Remark,
            UseColor,
            UseProcess,
            BatchNumber,
            BatchStartDate,
            DeliveryDate,
            WarehousePositionId
          } = arr[i]

          WarehouseId = WarehouseId ? WarehouseId : 0
          ColorId = ColorId ? ColorId : 0
          PropertyId = PropertyId ? PropertyId : 0
          Price = Price ?? 0
          Amount = Amount ?? 0

          let o = {
            T,
            Barcode: ProductNo,
            NewExpense,
            Cost,
            Amount2,
            DocProductId,
            DocId,
            WarehouseName,
            WarehouseId,
            ProductName,
            ProductId,
            ProductNo,
            ProductSpec,
            ColorName,
            ColorId,
            UnitId,
            UnitName,
            Quantity,
            ReQuantity,
            Price,
            Amount,
            UnitId2,
            UnitName2,
            Quantity2,
            ReQuantity2,
            Price2,
            Rate,
            InQuantity,
            InQuantity2,
            AccountQuantity,
            PropertyId,

            SourceId,
            SourceNo,
            IsGift,
            AvailableQuantity,
            ExistQuantity,
            SourceType,
            SourceDtsId,
            Remark,
            UseColor,
            UseProcess,
            BatchNumber,
            BatchStartDate,
            DeliveryDate,
            WarehousePositionId
          }

          Products.push(o)
        }
      } else if (mode === 1) {
        let length = this.delTableData.length

        for (let i = 0; i < length; ++i) {
          let {
            T,
            DocId = 0,
            NewExpense,
            Cost,
            Amount2,
            DocProductId = 0,
            WarehouseName,
            WarehouseId = 0,
            ProductName,
            ProductId,
            ProductNo,
            ProductSpec,
            ColorName,
            ColorId = 0,
            UnitId,
            UnitName,
            Quantity,
            ReQuantity,
            Price,
            Amount,
            UnitId2,
            UnitName2,
            Quantity2,
            ReQuantity2,
            Price2,
            Rate,
            InQuantity,
            InQuantity2,
            AccountQuantity,
            PropertyId,

            SourceId,
            SourceNo,
            IsGift,
            AvailableQuantity,
            ExistQuantity,
            SourceType,
            SourceDtsId,
            Remark,
            UseColor,
            UseProcess,
            BatchNumber,
            BatchStartDate,
            DeliveryDate,
            WarehousePositionId
          } = this.delTableData[i]

          WarehouseId = WarehouseId ? WarehouseId : 0
          ColorId = ColorId ? ColorId : 0
          PropertyId = PropertyId ?? 0
          Price = Price ?? 0
          Amount = Amount ?? 0

          let o = {
            T,
            Barcode: ProductNo,
            DocId,
            NewExpense,
            Cost,
            Amount2,
            DocProductId,
            WarehouseName,
            WarehouseId,
            ProductName,
            ProductId,
            ProductNo,
            ProductSpec,
            ColorName,
            ColorId,
            UnitId,
            UnitName,
            Quantity,
            ReQuantity,
            Price,
            Amount,
            UnitId2,
            UnitName2,
            Quantity2,
            ReQuantity2,
            Price2,
            Rate,
            InQuantity,
            InQuantity2,
            AccountQuantity,
            PropertyId,

            SourceId,
            SourceNo,
            IsGift,
            AvailableQuantity,
            ExistQuantity,
            SourceType,
            SourceDtsId,
            Remark,
            UseColor,
            UseProcess,
            BatchNumber,
            BatchStartDate,
            DeliveryDate,
            WarehousePositionId
          }

          Products.push(o)
        }
      }

      return Products
    },
    save(type = 0) {
      console.log('type', type)
      //验证表单是否填写
      let yanzheng = ['DocDate', 'DocNo', 'BusinessTypeId', 'TradeUnitId', 'WarehouseId', 'EmpId']

      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return
        }
      }

      console.log('this.tableData', JSON.parse(JSON.stringify(this.tableData)))

      let Products = this.getSaveTableData(this.tableData)
      console.log('Products 1', JSON.parse(JSON.stringify(Products)))

      if (Products.length > 0 && Products[0].ProductName != '') {
      } else {
        this.$message({ type: 'warning', message: '明细列表不能为空' })
        return
      }

      Products = Products.filter(item => {
        return item.T != null
      })

      var btId = 0
      var obj = this.businessTypeList.find(x => x.BusinessType == '采购退货')
      if (obj) btId = obj.BusinessTypeId

      let ProductsLength = Products.length
      for (let i = 0; i < ProductsLength; ++i) {
        if (this.data.BusinessTypeId == btId && btId) {
          if (Products[i].Amount > 0) {
            this.$message({ type: 'warning', message: '金额不能大于0' })
            return
          }
        } else {
          if (Products[i].Amount < 0) {
            this.$message({ type: 'warning', message: '金额不能小于0' })
            return
          }
        }
        if (Products[i].Quantity === 0 || Products[i].Quantity == null) {
          this.$message({ type: 'warning', message: '实收数量不能为0' })
          return
        }
        if (Products[i].UseColor && Products[i].ColorId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return
        }
        if (Products[i].UseProcess && Products[i].PropertyId === 0) {
          this.$message.error(`存货${Products[i].ProductName}未填写属性`)
          return
        }
      }

      let delProducts = this.getSaveTableData(this.delTableData, 1)

      Products = Products.concat(delProducts)
      console.log('Products 2', JSON.parse(JSON.stringify(Products)))

      let o = {
        Products,
        InType: this.data.InType,
        ...this.data
      }

      console.log('o', o)

      this.api.save(o).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.DocId = res.Data
          }
          if (type !== 1) {
            this.$message.success(res.Msg)
          }
          this.isSave = true
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              console.log('type', type)

              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data)
              }
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })

      this.isSave = true
    },
    handleDelete() {
      let id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete(id).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.getPreviewNo()
        this.isSave = false
        this.editTrade = true
      }
    },
    reView1() {
      let id = this.data.DocId
      this.api.updateStatus(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId
      this.api.cancelExamine(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    print() {
      let { DocDate, DocNo, BusinessType, WarehouseName, EmpName, MakeEmpName, ReviewEmpName, Remark, ReviewDate } = this.data

      let formData = [
        {
          key: 'DocDate',
          label: '单据时间',
          value: DocDate
        },
        {
          key: 'DocNo',
          label: '单据编号',
          value: DocNo
        },
        {
          key: 'BusinessType',
          label: '业务类型',
          value: BusinessType
        },
        {
          key: 'WarehouseName',
          label: '仓库',
          value: WarehouseName
        },
        {
          key: 'EmpName',
          label: '经手人',
          value: EmpName
        },
        {
          key: 'MakeEmpName',
          label: '制单人',
          value: MakeEmpName
        },
        {
          key: 'ReviewEmpName',
          label: '审核人',
          value: ReviewEmpName
        },
        {
          key: 'Remark',
          label: '备注',
          value: Remark
        },
        {
          key: 'ReviewDate',
          label: '审核日期',
          value: ReviewDate
        }
      ]
      this.formData = formData

      let columnData = []

      this.printList.forEach(item => {
        let o = {
          WarehouseName: item.WarehouseName,
          Barcode: item.Barcode,
          ProductName: item.ProductName,
          ProductNo: item.ProductNo,
          ProductSpec: item.ProductSpec,
          ColorName: item.ColorName,
          UnitName: item.UnitName,
          UnitName2: item.UnitName2,
          Quantity: item.Quantity,
          Quantity2: item.Quantity2,
          ReQuantity: item.ReQuantity,
          ReQuantity2: item.ReQuantity2,
          Price: item.Price,
          Price2: item.Price2,
          Amount: item.Amount
        }
        columnData.push(o)
      })

      this.columnData = columnData

      this.$refs.printDialog.open()
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      row.BatchNumber = ''
      this.batchPageParams.pageIndex = 1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        WarehouseId: row.WarehouseId,
        ColorId: row.colorId,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 选择批号 */
    onSelBatch(e, row, index) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (row.BatchNumber !== e.BatchNumber) {
        row.BatchNumber = e.BatchNumber
        row.ExistQuantity = e.BaseQuantity
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        BatchNumber: row.BatchNumber,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val
      let o = {
        IsInOut: 0,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        ProductName: row.ProductName,
        pageIndex: val,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号起始日期 */
    changeBatchStartDate(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    onChangeWarehousePosition(e, row, id) {
      if (e) {
        const o = { Status: 1, WarehouseId: id }
        this.warehousePositionApi.list(o).then(res => {
          let list = res.Data.map(item => {
            return {
              WarehousePositionId: item.WarehousePositionId,
              WarehousePositionName: item.WarehousePositionName
            }
          })
          this.$nextTick(() => {
            this.$delete(row, 'WarehousePositionList')
            this.$set(row, 'WarehousePositionList', list)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
}

.w180 {
  width: 180px;
}
</style>
